import React, { useEffect, useState } from "react";
import {
    Menu,
    Divider,
    Typography,
    TextField,
    ListItem,
    Grid,
} from "@material-ui/core";

import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Autocomplete from "@mui/material/Autocomplete";

import BusinessIcon from "@mui/icons-material/Business";

import UsuarioService from "../../services/usuarioService";
import EmpresaService from "../../services/empresaService";

import { useAuth } from "../../auth/ProvideAuth";
import { useHistory } from "react-router-dom";

import theme from "../../styles/theme";
import { Stack } from "@mui/material";

const MenuCardUser = (props) => {
    const history = useHistory();
    const auth = useAuth();
    const [empresas, setEmpresas] = useState([]);
    const empresaAtual = UsuarioService.getEmpresa();

    useEffect(() => {
        if (UsuarioService.getPerfil() == 1) {
            EmpresaService.buscaTodasAsEmpresas().then((empresas) => {
                setEmpresas(empresas);
            });
        }
    }, []);

    const getListItemStyle = (empresaID) => {
        return empresaID == empresaAtual
            ? {
                  backgroundColor: theme.palette.primary.dark,
                  color: theme.palette.primary.contrastText,
              }
            : {
                  cursor: "pointer",
              };
    };

    const handleTrocaEmpresa = (empresaID) => {
        UsuarioService.trocarEmpresa(empresaID).then(() => {
            props.handleMenuClose();
            auth.signout(() => {
                history.push("/login");
            });
        });
    };

    const getLabelEmpresa = (empresa) =>
        empresa
            ? `${empresa.razao_social.toUpperCase()} (${empresa.cnpj})`
            : "";

    return (
        <Menu
            keepMounted
            id={props.menuId}
            anchorEl={props.anchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            style={{ marginTop: "3.3rem", maxHeight: "25rem" }}
            open={props.isMenuOpen}
            onClose={props.handleMenuClose}
        >
            <Stack spacing={2} sx={{ width: 500, padding: 2 }}>
                <Typography variant="h6" align="center">
                    Empresas Disponíveis
                </Typography>
                <Divider light />
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <BusinessIcon color="primary" />
                    </Grid>
                    <Grid item>
                        <span>
                            Empresa Atual -{" "}
                            <strong>
                                {getLabelEmpresa(
                                    empresas.find((e) => e.id == empresaAtual)
                                )}
                            </strong>
                        </span>
                    </Grid>
                </Grid>
                <Divider light />
                <Autocomplete
                    options={empresas}
                    getOptionLabel={(option) => option.razao_social}
                    renderOption={(props, empresa) => {
                        return (
                            <ListItem
                                key={empresa.id}
                                style={getListItemStyle(empresa.id)}
                                onClick={() => handleTrocaEmpresa(empresa.id)}
                            >
                                <ListItemIcon>
                                    <BusinessIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText key={empresa.id}>
                                    {getLabelEmpresa(empresa)}
                                </ListItemText>
                            </ListItem>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField {...params} label="Razão Social" />
                    )}
                />
            </Stack>
        </Menu>
    );
};

export default MenuCardUser;
